import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import NewDonor from '../views/NewDonor.vue';
import GratitudeMessage from '@/components/GratitudeMessage.vue';
import NotFoundView from '@/components/HelloWorld.vue';
import NewDonorVitalsForm from '@/views/forms/NewDonorVitalsForm.vue';
import NewApheresisScreeningForm from '@/views/forms/NewApheresisScreeningForm.vue';
const routes = [
  {
    path: '/:facilityId',
    name: 'Home',
    component: Home,
  },
  {
    path: '/new-donor/:facilityId',
    name: 'NewDonor',
    component: NewDonor,
    props: true, 
  },
  {
    path: '/new-donor-vitals/:donor_id',
    name: 'NewDonorVitalsForm',
    component: NewDonorVitalsForm,
    props: true,
  },
  {
    path: '/new-apheresis-screening/:donor_id',
    name: 'NewApheresisScreeningForm',
    component: NewApheresisScreeningForm,
    props: true,
  },
  {
    path: '/gratitude',
    name: 'GratitudeMessage',
    component: GratitudeMessage,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundView
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
